<template>
  <div id="error">
    <dd-header
      :headerType=1
    />
    <main>
      <div class="content">
        <div v-for="(message, index) in errorMessages" :key="'error-' + index">{{message}}</div>
        <div class="toplink"><a @click="toLogin()">ログイン画面へ戻る</a></div>
      </div>
    </main>
  </div>
</template>

<script>
import Header from '../components/common/Header'
export default {
  name: 'Error',
  components: {
    'dd-header': Header
  },
  data () {
    return {
      errorMessages: ['システムエラーが発生しました。', 'しばらく時間をおいてから、再度操作してください。']
    }
  },
  methods: {
    toLogin: function () {
      this.$router.push({
        name: 'DcLogin'
      })
    }
  },
  created () {
    if (this.$route.params.errorMessages) {
      this.errorMessages = this.$route.params.errorMessages
    }
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#error {
  height: 100%;
}
main {
  height: 100%;
  text-align: center;
  color: #ff4500;
  font-weight: bold;
  word-wrap: break-word;
  line-height: 25px;
  padding: 0;
  overflow: auto;
  .content {
    padding: 20px;
    margin-top: 83px;
    background-color: white;
    height: calc(100% - 123px);
  }
  .toplink {
    margin-top: 25px;
  }
}
</style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/Error.vue